<template>
    <div v-if="items && items.length"
         v-observe="handleView"
         :class="wrapperClass">
        <div class="dml-last-clicked__heading">
            <svg width="48" height="48" viewBox="0 0 48 48">
                <g clip-path="url(#a)" fill="none">
                    <circle cx="27.6" cy="27.6" r="20.4" fill="#FFB5B5" style="mix-blend-mode:multiply" />
                    <circle cx="21" cy="21" r="20.5" stroke="#000" stroke-linejoin="round" />
                    <path d="M9.05 25.083c.81 3.012 2.87 5.556 5.724 7.072 2.854 1.517 6.271 1.88 9.498 1.013 3.227-.868 6-2.896 7.71-5.64 1.71-2.743 2.214-5.976 1.404-8.988" stroke="#000" stroke-linecap="round" stroke-linejoin="round" />
                    <ellipse transform="rotate(-15.05 15.635 17.224)" cx="15.635" cy="17.224" rx="1.68" ry="4.2" fill="#000" />
                    <ellipse transform="rotate(-15.05 25.37 14.606)" cx="25.369" cy="14.606" rx="1.68" ry="4.2" fill="#000" />
                </g>
                <defs>
                    <clipPath id="a">
                        <path d="M0 0h48v48H0z" fill="#fff" />
                    </clipPath>
                </defs>
            </svg>
            <span class="dml-last-clicked__title">Ostatnio oglądane...</span>
            <span class="dml-last-clicked__subtitle">...i nasze rekomendacje dla Ciebie</span>
        </div>
        <dm-scrollable-list className="dml-last-clicked-products"
                            innerClassName="dml-last-clicked-products__list"
                            navClassName="dml-last-clicked-products__nav"
                            :itemsInViewport="5"
                            :columnsTotal="items.length"
                            v-on:scroll.once="handleScroll">
            <template slot="items">
                <li v-for="(item, index) in items"
                    class="dml-last-clicked-products__item"
                    :key="index">
                    <dm-product-item :model="item" 
                                     v-on:productClick="handleClick" />
                </li>
            </template>
        </dm-scrollable-list>
    </div>
</template>
<script>
    import ProductItem from '../product-list/product-item-component';
    import ScrollableListComponent from './scrollable-list-component.vue';
    import observe from "~/directives/observe.js";

    export default {
        name: 'dm-last-clicked-products',
        data() {
            return {
                items: [],
            }
        },
        components: {
            'dm-product-item': ProductItem,
            'dm-scrollable-list': ScrollableListComponent,
        },
        directives: {
            observe: observe
        },
        mounted() {
            DM.Service.LastClicked.getProducts(this.forcePreviewParam).then((data) => {
                this.items = data;
            });
        },
        props: {
            forcePreviewParam: {
                type: String,
                required: false
            },
            place: {
                type: String,
                required: true
            }
        },
        computed: {
            wrapperClass() {
                const baseClass = 'dml-last-clicked';
                return this.place !== 'main_page' ? baseClass : `${baseClass} ${baseClass}--main-page`
            },
        },
        methods: {
            handleClick() {
                this.$ga.trackEvent({
                    category: 'last_seen_products',
                    action: 'click_last_seen_products',
                    label: this.place
                });
            },
            handleScroll() {
                this.$ga.trackEvent({
                    category: 'last_seen_products',
                    action: 'scroll_last_seen_products',
                    label: this.place
                });
            },
            handleView() {
                this.$ga.trackEvent({
                    category: 'last_seen_products',
                    action: 'view_last_seen_products_section',
                    label: this.place
                });
            }
        },
    };
</script>

<style>
    @import '../../../scss/config.scss';

    .#{$ns}last-clicked {
        padding-bottom: $pr-size-x3;
        margin: $pr-size-x3 0 $pr-size-x2;
        border-top: 1px solid #ECECEC;
        border-bottom: 1px solid #ECECEC;

        &--main-page {
            margin-bottom: $pr-size-x7;
            border: none;

            &__heading {
                border: none;
            }
        }

        &__heading {
            position: relative;
            padding: $pr-size-x4 0 $pr-size-x2 $pr-size-x2;

            @media(min-width: $pr-br-large) {
                padding: $pr-size-x3 0 $pr-size-x2 $pr-size-x10;
                margin-top: 0;
            }

            svg {
                position: absolute;
                top: -$pr-size-x3;
                left: 0;
                background-color: $pr-color--white;
                width: $pr-size-x10;

                @media(min-width: $pr-br-large) {
                    width: $pr-size-x6;
                    top: ($pr-size-d2 * 7);
                    left: $pr-size-x2;
                }
            }
        }

        &__title {
            display: block;
            font-size: 24px;
            line-height: 32px;
        }

        &__subtitle {
            display: block;
            font-size: 16px;
            line-height: 24px;
            color: $pr-color-gray-48;
        }
    }

    .#{$ns}last-clicked-products {
        position: relative;

        &__list {
            position: relative;
            display: flex;
            padding: $pr-size-x1 0 0 $pr-size-x2;
            margin: 0;
            flex-wrap: nowrap;
            list-style: none;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;

            @media(min-width: $pr-br-large) {
                padding: 0;
                overflow: hidden;
            }
        }

        &__nav {
            display: none;
            justify-content: center;
            align-items: center;
            position: absolute;
            top: 50%;
            margin-top: -$pr-size-x8;
            padding: 0;
            width: $pr-size-x8;
            height: $pr-size-x8;
            border: 0;
            border-radius: $pr-size-x4;
            background-color: $pr-color--white;
            box-shadow: 0px 0px 32px rgba(0, 0, 0, 0.08);
            z-index: $pr-layer-cover;

            @media(min-width: $pr-br-large) {
                display: flex;
            }

            &--backward {
                left: -$pr-size-x2;
            }

            &--forward {
                right: -$pr-size-x2;
            }

            svg {
                flex-shrink: 0;
                width: $pr-size-x2;
                height: $pr-size-x2;
                stroke: $pr-color--black;
            }
        }

        &__item {
            display: inline-block;
            width: 56.04%;
            margin-right: $pr-size-x2;
            flex-shrink: 0;

            @media (min-width: $pr-br-medium) {
                width: 20%;
                padding: 0 $pr-size-x2;
                margin: 0;
            }
        }
    }
</style>
